import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * angle 列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	angleList( params={} ) {
		return request({
	    url: baseUrl + '/tiltSensor/index',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * angle 添加
	**/
	angleAdd(data){
		return request({
			url: baseUrl + '/tiltSensor/tilt',
			method:'POST',
			data
		})
	},

	/**
	 * angle 编辑
	**/
	angleEdit(id,data){
		return request({
			url: baseUrl + '/tiltSensor/tilt/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * angle 删除
	**/
	angleDel(id){
		return request({
			url: baseUrl + '/tiltSensor/tilt/'+id,
			method:'DELETE'
		})
	},

	/**
	 * angle 设置倾斜角
	**/
	setAngle(id,data){
		return request({
			url: baseUrl + '/tiltSensor/setAngle/'+id,
			method:'POST',
			data
		})
	}
}